import { render, staticRenderFns } from "./TabbedPane.vue?vue&type=template&id=c8a98b5e&scoped=true"
import script from "./TabbedPane.vue?vue&type=script&lang=js"
export * from "./TabbedPane.vue?vue&type=script&lang=js"
import style0 from "./TabbedPane.vue?vue&type=style&index=0&id=c8a98b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a98b5e",
  null
  
)

export default component.exports